import React from 'react';
import PropTypes from 'prop-types';
import PurchaseModal from '../../../containers/PurchaseModal';
import Translate, { translate } from '../../Translate';
import DefaultModal from '../../Modals';

const modalMessages = {
  purchase: (intl, modal, entity) => {
    const pending = ['bank', 'ticket'].includes(entity) ? 'pending.' : '';
    return ({
      title: translate(intl, `PaymentStatus.subscription.messages.${pending}${modal?.code}.title`, {
        defaultMessage: translate(intl, `PaymentStatus.subscription.messages.${modal?.default}.title`)
      }),
      description: translate(intl, `PaymentStatus.subscription.messages.${pending}${modal?.code}.body`, {
        defaultMessage: translate(intl, `PaymentStatus.subscription.messages.${modal?.default}.body`)
      }),
      secondaryButton: translate(intl, `PaymentStatus.subscription.buttons.${pending}${modal?.code}.submit`, {
        defaultMessage: translate(intl, `PaymentStatus.subscription.buttons.${modal?.default}.submit`)
      }),
    })
  },
  forceToChangeToFavorite: (intl) => {
    return ({
      title: translate(intl, `MyAccount.paymentMethdos.modalForceToChangeToFavorite.title`),
      description: translate(intl, `MyAccount.paymentMethdos.modalForceToChangeToFavorite.description`),
      primaryButton: translate(intl, `MyAccount.paymentMethdos.modalForceToChangeToFavorite.primaryButton`),
      secondaryButton: translate(intl, `MyAccount.paymentMethdos.modalForceToChangeToFavorite.secondaryButton`),
    })
  },
  newPaymentMethod: (intl, modal) => {
    return ({
      title: translate(intl, `PaymentMethodSelector.methods.newPaymentMethod.${modal?.code}.title`, {
        defaultMessage: translate(intl, `PaymentMethodSelector.methods.newPaymentMethod.default.title`)
      }),
      description: translate(intl, `PaymentMethodSelector.methods.newPaymentMethod.${modal?.code}.body`, {
        defaultMessage: translate(intl, `PaymentMethodSelector.methods.newPaymentMethod.${modal?.default}.body`)
      }),
      secondaryButton: translate(intl, `PaymentMethodSelector.methods.newPaymentMethod.${modal?.code}.submit`, {
        defaultMessage: translate(intl, `PaymentMethodSelector.methods.newPaymentMethod.default.submit`)
      }),
    })
  },
}
const SubPaymentMethodModal = (props) => {
  const { modal, intl, type, entity } = props;
  if (!props.modal || !props.modal.handleClick) {
    return null;
  }
  const func = modalMessages[type] || modalMessages[modal.type] || modalMessages.purchase;
  const messages = func(intl, modal, entity);

  if (modal.modalType === 'default') {
    return (
      <DefaultModal
        title={messages.title}
        description={messages.description}
        isOpenModal={Boolean(modal)}
        onToggleModal={false}
        secondaryButton={{
          text: messages.secondaryButton,
          onClick: () => { modal.handleClick() }
        }}
        {...(messages.primaryButton && { primaryButton : {
          text: messages.primaryButton,
          onClick: () => { modal.handlePrimaryClick() }
        } })}
      />
    )
  }

  return (
    <PurchaseModal
      isOpenModal={Boolean(modal)}
      onToggleModal={false}
      code={modal?.code}
      transaction={modal?.transaction}
      image={modal?.img && (
        <img className="PaymentStatus__img" src={modal?.img} alt="modal payment status" />
      )}
      title={messages.title}
      description={modal?.message || messages.description}
      errorDescription={
        <Translate
          id="PaymentStatus.subscription.messages.default.status"
          values={{ code: modal?.code || 'unknown' }}
        />
      }
      activateButton={{
        isNeutral: false,
        text: {
          unlinked: translate(intl, 'PaymentStatus.subscription.buttons.default.submit.unlinked'),
          linked: translate(intl, 'PaymentStatus.subscription.buttons.default.submit.linked')
        }
      }}
      secondaryButton={{
        text: messages.secondaryButton,
        onClick: () => { modal.handleClick() }
      }}
    />
  );
}

SubPaymentMethodModal.propTypes = {
  modal: PropTypes.shape({
    modalType: PropTypes.string,
    type: PropTypes.string,
    handleClick: PropTypes.func,
    code: PropTypes.number,
    default: PropTypes.string,
    img: PropTypes.string,
    transaction: PropTypes.string,
  }),
  type: PropTypes.string,
  entity: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
}

export default SubPaymentMethodModal;
